export default __webpack_public_path__ + "static/media/logo_fibromialgia.11789143.png";